import React from 'react';
import ReactDOM from 'react-dom/client';
import ShelfRouter from './router/router';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import antdTheme from './theme/antdTheme';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const originalConsoleError = console.error;

console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        args[0].includes('When calling super()') &&
        args[0].includes('make sure to pass up the same props')
    ) {
        return;
    }
    originalConsoleError(...args);
};

root.render(
    <ConfigProvider theme={antdTheme} locale={esES}>
        <ShelfRouter />
    </ConfigProvider>
);
